import { mapDTO } from '@twistezo/ts-dto-mapper'

import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { DomainAmazonAlert } from 'features/globalSetup/features/amazon/types/domainAmazonAlert'
import { DomainAmazonSlice } from '../types'
import { DomainAmazonSliceDTO } from './types'

type From = DomainAmazonSliceDTO
type To = DomainAmazonSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((data: From): To => {
    const { fieldAlerts } = data

    return {
      alerts: alertsFromDTO<DomainAmazonAlert>(fieldAlerts),
    }
  })
